import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';
import { useLanguage } from '../../context/language';

const StyledCvSection = styled.section`
  max-width: 760px;

  .intro {
    margin-bottom: 18px;
  }

  .cv-card {
    ${({ theme }) => theme.mixins.boxShadow};
    background: var(--surface);
    border: 1px solid var(--surface-border);
    border-radius: var(--border-radius);
    padding: 20px;
  }

  h3 {
    margin: 0 0 6px;
    font-size: var(--fz-xxl);
    color: var(--lightest-slate);
  }

  .subtitle {
    margin: 0;
    color: var(--light-slate);
    font-family: var(--font-mono);
    font-size: var(--fz-xxs);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: 16px;
  }

  .download-link {
    ${({ theme }) => theme.mixins.smallButton};
    display: inline-flex;
  }
`;

const Cv = () => {
  const { content } = useLanguage();
  const cv = content.cv;
  const revealTitle = useRef(null);
  const revealCard = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealTitle.current, srConfig());
    sr.reveal(revealCard.current, srConfig(100));
  }, [prefersReducedMotion, content]);

  return (
    <StyledCvSection id="cv">
      <h2 className="numbered-heading" ref={revealTitle}>
        {cv.heading}
      </h2>

      <p className="intro">{cv.description}</p>

      <article className="cv-card" ref={revealCard}>
        <h3>{cv.title}</h3>
        <p className="subtitle">{cv.subtitle}</p>
        <a className="download-link" href={cv.file.url} download={cv.file.downloadName}>
          {cv.downloadCta}
        </a>
      </article>
    </StyledCvSection>
  );
};

export default Cv;
